import React from "react";

const Services = ({ classicHeader, darkTheme }) => {
  // services details
  const services = [
    {
      name: "Graphic Design",
      desc: "Specializing in creating visually impactful designs, I offer comprehensive graphic design services that effectively communicate your brand's message. From branding to digital content, I ensure each design aligns strategically with your business goals.",
      icon: "fas fa-palette",
    },
    {
      name: "Web Design",
      desc: "My web design services focus on crafting responsive, user-centric websites that embody the latest trends and best practices. Understanding your unique needs, I deliver custom web solutions that enhance user engagement and digital presence.",
      icon: "fas fa-desktop",
    },
    {
      name: "UI/UX Design",
      desc: "With a focus on user experience, I provide UI/UX design services for mobile apps and web platforms. My designs are carefully crafted to enhance usability, ensuring a seamless and intuitive user interface that elevates user satisfaction.",
      icon: "fas fa-pencil-ruler",
    },
    {
      name: "Business Analysis",
      desc: "As a business analyst, I apply strategic thinking to solve complex challenges. Utilizing data analysis and process optimization, I offer insights and solutions to improve business operations and achieve efficiency and growth.",
      icon: "fas fa-chart-area",
    },
    {
      name: "Marketing",
      desc: "I offer comprehensive marketing services to elevate your brand's presence. Combining traditional and digital strategies, I create and execute campaigns that resonate with your audience, ensuring meaningful engagement and outreach.",
      icon: "fas fa-bullhorn",
    },
    {
      name: "Banking Insights",
      desc: "Your trusted resource for all banking-related queries. From understanding different types of bank accounts to navigating investment options, our expert advice is tailored to help you make informed financial decisions. Whether you're planning for retirement or managing your daily expenses, we provide guidance to secure and grow your wealth.",
      icon: "fas fa-piggy-bank",
    },
    {
      name: "Administration",
      desc: "As an experienced administrator, I ensure efficient management of organizational tasks. My services include office management, scheduling, and workflow optimization to maintain smooth operations and free you to focus on your business.",
      icon: "fas fa-user-tie",
    },
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Services
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I Do?
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        <i className={service.icon} />
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        {service.desc}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
